import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import FileOpeningRegisterPdf from './FileOpeningRegisterPdf';

const getDate = () => {
  const dateObj = new Date();
  const month = dateObj.getUTCMonth() + 1; // months from 1-12
  const day = dateObj.getUTCDate();
  const year = dateObj.getUTCFullYear();
  return day + "-" + month + "-" + year;
}

const FileOpeningRegisterPdfButton = ({ data, version }) => {
  if (!data || !data.length) {
    return null;
  }

  return (
    <PDFDownloadLink document={<FileOpeningRegisterPdf data={data} key={version} />} fileName={`file-opening-Register-${getDate()}.pdf`}>
      {({ blob, url, loading, error }) =>
        loading ? 'Loading document...' : <button key={version + 1} className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded-md shadow">Download PDF</button>
      }
    </PDFDownloadLink>
  );
};

export default FileOpeningRegisterPdfButton;
